import { render } from "./week-dues.vue?vue&type=template&id=2e4d6e6c&scoped=true"
import script from "./week-dues.vue?vue&type=script&lang=js"
export * from "./week-dues.vue?vue&type=script&lang=js"

import "./week-dues.vue?vue&type=style&index=0&id=2e4d6e6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4d6e6c"]])

export default __exports__